module.exports = __webpack_public_path__ + "static/img/award4.45085dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/award4.png
// module id = 703W
// module chunks = 0